export default "__VITE_ASSET__BAA79qvj__"